import React from 'react';
import CartDetail from '../CartDetail/CartDetail';


const Cart = (props) => {
    const players=props.cart
    let totalSalary=0
    return (
        <div >
            <h4>Player Selected: {props.cart.length}</h4>
            {
                players.map(player=>{

                    return <CartDetail player={player}></CartDetail>
                })                    
            }
            {
                players.map(player=>{
                    totalSalary+=player.salary
                })
            }                 
            <h4>Total Salary:{totalSalary}</h4>
            
        </div>
    );
};

export default Cart;